module.exports = __webpack_public_path__ + "static/media/rotate_screen_icon.670857cd.gif";